import { Table as MantineTable } from '@mantine/core'
import { useTableContext } from '../context/table-provider'
import styled from 'styled-components'
import { Icon, TableRow } from '@percent/lemonade'

const TableHeadWrapper = styled.div<{ isSortable?: boolean }>`
  display: inline-flex;
  width: fit-content;
  gap: 8px;
  align-items: center;
  ${(p) => p.isSortable && 'cursor: pointer;'}
`

const StyledTableHeader = styled(MantineTable.Th)<{
  $bgColor?: string
}>`
  ${({ theme, $bgColor }) => `
    color: black;
    font-weight: 500;
    background-color: ${$bgColor || 'white'};
    font-size: ${theme.fontSizes.bodySmall};
    border-bottom: 1px solid ${theme.colors.gray80};
    padding: 14px 8px;

    &:first-child {
      padding-left: 16px;
    }

    &:last-child {
      padding-right: 16px;
    }
  `}
`

export function TableHeader() {
  const {
    columns,
    tableHeadTestId,
    handleRequestSort,
    sortDirection,
    sortByColumn,
  } = useTableContext()

  return (
    <MantineTable.Thead data-testid={tableHeadTestId}>
      <TableRow>
        {columns.map((col) => (
          <StyledTableHeader
            key={col.id}
            style={{ ...col.props }}
            $bgColor={col.bgColor}
          >
            <TableHeadWrapper
              isSortable={col.isSortable}
              onClick={() => col.isSortable && handleRequestSort?.(col.id)}
            >
              {/* An omitted `content` falls back to the column id (a rough
                  last-resort heading); an explicitly empty one is a deliberately
                  unheaded column — an action column, or a key column whose rows
                  speak for themselves — and must stay blank rather than leaking
                  the internal id into the header. */}
              {col.content ?? col.id}
              {handleRequestSort &&
                col.isSortable &&
                sortByColumn !== col.id && (
                  <Icon
                    name="sort"
                    size={6}
                    customTestId={`table-${col.id}-default-sort-icon`}
                  />
                )}
              {sortByColumn === col.id &&
                (sortDirection === 'ASC' ? (
                  <Icon
                    name="sort-asc"
                    size={6}
                    customTestId={`table-${col.id}-asc-sort-icon`}
                  />
                ) : (
                  <Icon
                    name="sort-desc"
                    size={6}
                    customTestId={`table-${col.id}-desc-sort-icon`}
                  />
                ))}
            </TableHeadWrapper>
          </StyledTableHeader>
        ))}
      </TableRow>
    </MantineTable.Thead>
  )
}
